const GiftCardUsageArea = Object.freeze({
  ALL_CHAINS: 1,
  CHAIN_WISE: 2,
  SITE_WISE: 3,
});

export default GiftCardUsageArea;
